import React, { useState, useEffect, ReactNode } from "react";
import { navigate } from "gatsby";
import { useAuthContext } from "../../contexts/AuthProvider";
import Loading from "../Loading";
import axios from "axios";

function AdminPrivateRoute({ children }: { children: ReactNode }) {
  const { user, setUser } = useAuthContext();
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only fetch user status if we don't already have a user
    // (optional logic — if you always want to re-check, remove this condition)
    if (!user) {
      axios
        .get("/api/user/status")
        .then((res) => {
          setUser(res.data);
          setAuthenticated(true);
        })
        .catch(() => {
          setAuthenticated(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      // If user is already known, no need to re-check
      setAuthenticated(true);
      setLoading(false);
    }

    // Cleanup or any additional logic
    return () => {
      // In most cases no special cleanup needed here
    };
  }, [user, setUser]);

  useEffect(() => {
    if (!loading && !authenticated) {
      navigate("/login");
    }
  }, [loading, authenticated]);

  if (loading || !authenticated) {
    return <Loading position="relative" height="h-[calc(100vh-64px)]" />;
  }

  return <>{children}</>;
}

export default AdminPrivateRoute;
